import { keyframes } from '@chakra-ui/react';
import { valueToPercent, isFunction } from '@chakra-ui/utils';
var animation = keyframes({
  '0%': {
    left: '-40%'
  },
  '100%': {
    left: '100%'
  }
});

/**
 * Get the common `aria-*` attributes for the progress components
 */
function getProgressProps(options) {
  var _options$value = options.value,
    value = _options$value === void 0 ? 0 : _options$value,
    min = options.min,
    max = options.max,
    valueText = options.valueText,
    getValueText = options.getValueText,
    isIndeterminate = options.isIndeterminate;
  var percent = valueToPercent(value, min, max);
  var getAriaValueText = function getAriaValueText() {
    if (value == null) return undefined;
    return isFunction(getValueText) ? getValueText(value, percent) : valueText;
  };
  return {
    bind: {
      'data-indeterminate': isIndeterminate ? '' : undefined,
      'aria-valuemax': max,
      'aria-valuemin': min,
      'aria-valuenow': isIndeterminate ? undefined : value,
      'aria-valuetext': getAriaValueText(),
      role: 'progressbar'
    },
    percent: percent,
    value: value
  };
}
export { animation, getProgressProps };